// extracted by mini-css-extract-plugin
export var quillEditor = "_gs-1";
export var variable = "_gs-0";